import { Box } from "@vapor/react-material";
import React from "react";

export const BannerImageNotFound = () => {
  return (
    <Box
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <img src="banner-notfound.png" alt="not found"></img>
    </Box>
  );
};
